import { FormInput } from "components/Form/next";
import { useRouter } from "next/router";
import React from "react";
import { useTranslation } from "react-i18next";
import { useMessageTemplates } from "../hooks";

interface Props {
    clubSlug?: string;
    name?: string;
    label?: string;
}

export const TemplateFields = ({
    clubSlug,
    name = "mail_message_template_id",
    label,
}: Props) => {
    const { t } = useTranslation("message-management");
    const { query } = useRouter();
    const { templates } = useMessageTemplates(String(query.slug) || clubSlug);

    return (
        <FormInput.Select
            name={name}
            label={label ?? t("template.fields.templateLabel")}
            options={templates.map((template) => ({
                key: String(template.id),
                label: template.title,
            }))}
        />
    );
};
